/*
 * ============================================================================
 * Pet Portrait — Complete the Collection tabbed cross-sell  (<pet-portrait-tabs>)
 * ----------------------------------------------------------------------------
 * A tab bar + product panels. Each tab maps 1:1 to a panel (same index). The
 * element wires clicks + keyboard (arrow / Home / End) on the tabs and toggles
 * which panel is visible via the [hidden] attribute (CSS drives display off it,
 * so the first panel still shows if JS never runs).
 *
 * ARIA: tabs are role="tab", panels role="tabpanel"; aria-selected + roving
 * tabindex follow the active tab. All panels stay in the DOM so the store's
 * Loox star widgets render on load regardless of which tab is open.
 *
 * One class-based custom element per section; self-contained + namespaced `pp-`
 * for portability. Listeners are cleaned up on disconnect (no leaks).
 * ============================================================================
 */
(function () {
  'use strict';

  var TAG = 'pet-portrait-tabs';

  class PetPortraitTabs extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-pp-tab]'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-pp-panel]'));
      if (!this.tabs.length) return;

      this._wired = true;
      this._onClick = this.onClick.bind(this);
      this._onKey = this.onKey.bind(this);

      var self = this;
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', self._onClick);
        tab.addEventListener('keydown', self._onKey);
      });

      // Honour a pre-selected tab (aria-selected="true"), else the first.
      var start = 0;
      for (var i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].getAttribute('aria-selected') === 'true') { start = i; break; }
      }
      this.select(start, false);
    }

    disconnectedCallback() {
      if (!this._wired) return;
      var self = this;
      this.tabs.forEach(function (tab) {
        tab.removeEventListener('click', self._onClick);
        tab.removeEventListener('keydown', self._onKey);
      });
      this._wired = false;
    }

    onClick(e) {
      var idx = this.tabs.indexOf(e.currentTarget);
      if (idx > -1) this.select(idx, false);
    }

    onKey(e) {
      var idx = this.tabs.indexOf(e.currentTarget);
      if (idx === -1) return;
      var next;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % this.tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + this.tabs.length) % this.tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = this.tabs.length - 1;
      else return;
      e.preventDefault();
      this.select(next, true);
    }

    select(index, focus) {
      for (var i = 0; i < this.tabs.length; i++) {
        var active = i === index;
        var tab = this.tabs[i];
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
        var panel = this.panels[i];
        if (panel) {
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        }
      }
      if (focus && this.tabs[index]) this.tabs[index].focus();
    }
  }

  if (window.customElements && !window.customElements.get(TAG)) {
    window.customElements.define(TAG, PetPortraitTabs);
  }
})();
